<template>
  <div>
    <div
      v-for="tranTypeOption in transactionTypesOptions.filter(option => option.key == transactionType)"
      :key="tranTypeOption.key"
    >
      <span style="height: 30px;float: left;margin-right: 12px;">
        <v-img
          style="display: inline-block;"
          max-height="30"
          width="30"
          contain
          :src="tranTypeOption.icon"
        />
      </span>
      <span
        :style="{
          'font-size': '14px',
          'line-height': '30px',
          height: '30px',
          color: tranTypeOption.color
        }"
      >
        {{ tranTypeOption.shortText }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    transactionType: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('transaction', [
      'transactionTypesOptions'
    ])
  }
}
</script>

<style></style>
